export const CUR_YEAR = 2023;
